<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
              variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h6 mt-2">Exports des inscrits {{ mainStore.module.nom }}</div>
            <div class="d-flex gap">
              <a target="_blank" :href="base_url + 'Export_CSV/export_gmcap.php?id=' + mainStore.module.id"><v-btn
                  color="primary-dark" variant="tonal">CSV pour GMCAP</v-btn></a>
              <a target="_blank" :href="base_url + 'Export_CSV/export_complet.php?id=' + mainStore.module.id"><v-btn
                  color="primary-dark" variant="tonal">CSV complet</v-btn></a>
              <a target="_blank"
                :href="base_url + 'Accueil_Sportips_App/QRCode_Accueil/get.php?id=' + mainStore.module.id"><v-btn
                  color="primary-dark" variant="tonal">QRCode d'identification pour l'accueil des
                  participants</v-btn></a>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  components: {},
  data() {
    return {
      base_url: process.env.VUE_APP_API_BASE,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {},
  created() {

  },
};
</script>

<style lang="scss" scoped></style>